import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { UserRemoveType } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/enums";
import { UnitNodePermissions } from "../unit/unitNodePermissions";
import { UserEdit } from "../user/userEdit";
import { UserEditSaveSuccess } from "../user/userEditSaveSuccess";
import { UserListItems } from "../user/userListItems";
import { UserProfileEdit } from "../user/userProfileEdit";
import { UsersPage } from "../user/usersPage";
import { UsersPageUserGroups } from "../user/usersPageUserGroups";
import { getApiCall, getFileApiCall, postApiCall } from "./tokenService";
import { ReportGenerated2 } from "../report/reportGenerated2";
import { UserPasswordEmailResult } from "../user/userPasswordEmailResult";

// #region UserPage
export const getUsersPage = (): Promise<UsersPage> => {
    return getApiCall("api/user", UsersPage);
};

export const getUserListItems = (companyId: string, pageSize: number, page: number, filter: string, userGroupIds: string[], activityState: number, sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
    return postApiCall("api/user/list", UserListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        userGroupIds,
        activityState
    }));
};

export const getUsersPageUserGroups = (companyId: string): Promise<UsersPageUserGroups> => {
    return getApiCall("api/user/pageusergroups?id=" + companyId, UsersPageUserGroups);
};

export const getUserEdit = (companyId: string, userId: string, userType: number): Promise<UserEdit> => {
    return getApiCall("api/user/edit?id=" + userId + "&companyId=" + companyId + "&userType=" + userType.toString(10), UserEdit);
};

export const saveUserEdit = (obj: any): Promise<UserEditSaveSuccess> => {
    return postApiCall("api/user/editsave", UserEditSaveSuccess, JSON.stringify(obj));
};

export const getUserQrCodePrint = (companyId: string, userId: string): Promise<string> => {
    return getFileApiCall("api/user/qrcodeprint?id=" + userId + "&companyId=" + companyId);
};

export const checkUserCode = (id: string, companyId: string, code: string): Promise<ApiSuccess> => {
    return postApiCall("api/user/checkusercode", ApiSuccess, JSON.stringify({ id, companyId, code }));
};

export const removeUser = (id: string, companyId: string, removeType: UserRemoveType): Promise<ApiSuccess> => {
    return postApiCall("api/user/remove?id=" + id + "&companyId=" + companyId + "&removeType=" + removeType.toString(10), ApiSuccess);
};

export const userEditChangePassword = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/user/editchangepassword", SaveSuccess, JSON.stringify(obj));
};

export const userEditRemoveUserGroups = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/user/editremoveusergroups", ApiSuccess, JSON.stringify(obj));
};

export const userEditAddUserGroups = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/user/editaddusergroups", ApiSuccess, JSON.stringify(obj));
};
// #endregion UserPage

// #region Import
export const downloadImportTemplate = (): Promise<string> => {
    return getFileApiCall("api/user/downloadimporttemplate");
};

export const uploadImportFile = (obj: any): Promise<ReportGenerated2> => {
    return postApiCall("api/user/uploadimportfile", ReportGenerated2, JSON.stringify(obj));
};

export const importUsers = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/user/import", ApiSuccess, JSON.stringify(obj));
};
// #endregion Import

// #region Email
export const sendInvitationEmail = (id: string, companyId: string): Promise<UserPasswordEmailResult> => {
    return postApiCall("api/user/invitationemail", UserPasswordEmailResult, JSON.stringify({ id, companyId }));
};

export const sendPasswordChangeEmail = (id: string, companyId: string): Promise<UserPasswordEmailResult> => {
    return postApiCall("api/user/passwordchangeemail", UserPasswordEmailResult, JSON.stringify({ id, companyId }));
};
// #endregion Email

// #region Module properties
export const getUnitNodePermissions = (companyId: string): Promise<UnitNodePermissions> => {
    return getApiCall("api/user/module/permissions?id=" + companyId, UnitNodePermissions);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/user/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module properties

// #region UserProfile
export const getUserProfileEdit = (): Promise<UserProfileEdit> => {
    return getApiCall("api/user/profile", UserProfileEdit);
};

export const saveUserProfile = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/user/profilesave", SaveSuccess, JSON.stringify(obj));
};

export const changePassword = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/user/profilechangepassword", SaveSuccess, JSON.stringify(obj));
};

export const saveThirdPartyAuthentication = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/user/profilethirdpartyauthenticationsave", ApiSuccess, JSON.stringify(obj));
};
// #endregion UserProfile

// #region UserSelect
export const getUserSelectListItems = (companyId: string, pageSize: number, page: number, filter: string, ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number,
    ignoreRecordUserConnected: boolean, ignoreQrCodeUsers: boolean, requireQrCodeUsers: boolean, doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
    return postApiCall("api/user/selectlist", UserListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreUserIds,
        ignoreUserCodes,
        ignoreRecordUserConnected,
        ignoreQrCodeUsers: ignoreQrCodeUsers ?? false,
        requireQrCodeUsers: requireQrCodeUsers ?? false,
        doNotIgnoreRecordUserConnectedUserCode,
        activityState,
    }));
};
// #endregion UserSelect

//User parameter
// #region User parameter
export const saveUserParameter = (code: string, value: string): Promise<ApiSuccess> => {
    return postApiCall("api/userparameter/save", ApiSuccess, JSON.stringify({
        code,
        value
    }));
};
// #endregion  User parameter
